import { PropsWithChildren } from "react";

import { usePermissionsContext, type PermissionsContextType } from "#app/PermissionsProvider";

type Props = { feature: keyof PermissionsContextType };

export const useCan = (feature: Props["feature"]): boolean => {
  const permissions = usePermissionsContext();

  return permissions[feature];
};

export const Can = ({ feature, children }: PropsWithChildren<Props>) => {
  const can = useCan(feature);

  return can ? children : null;
};
